/* ==========================================================================
   Doll Faced Rebellion — product-media.js
   Swaps the product page's main photo to match the selected color variant,
   and drives the thumbnail strip under the main photo.
   Each color already has its own image assigned in Shopify (with the
   graphic printed on that color).
   ========================================================================== */

(function () {
  "use strict";

  var mediaImg = document.querySelector("[data-product-media-img]");
  if (!mediaImg) return;

  function baseName(src) {
    if (!src) return "";
    return src.split("?")[0].split("/").pop();
  }

  var thumbs = [].slice.call(document.querySelectorAll("[data-media-thumb]"));

  function markThumbs() {
    var current = baseName(mediaImg.getAttribute("src"));
    thumbs.forEach(function (t) {
      var on = baseName(t.getAttribute("data-src")) === current;
      t.setAttribute("aria-current", on ? "true" : "false");
    });
  }

  function setMain(src, alt) {
    if (!src) return;
    if (src.indexOf("width=") === -1) {
      src += (src.indexOf("?") === -1 ? "?" : "&") + "width=900";
    }
    mediaImg.src = src;
    if (alt) mediaImg.alt = alt;
    markThumbs();
  }

  thumbs.forEach(function (t) {
    t.addEventListener("click", function () {
      setMain(t.getAttribute("data-src"), t.getAttribute("data-alt"));
    });
  });
  markThumbs();

  document.querySelectorAll("[data-product-form]").forEach(function (form) {
    var variants = [];
    try {
      variants = JSON.parse(form.getAttribute("data-variants"));
    } catch (err) {
      return;
    }
    if (!variants || !variants.length) return;

    var optionCount = form.getAttribute("data-option-count") ? parseInt(form.getAttribute("data-option-count"), 10) : 1;
    var selected = new Array(optionCount).fill(null);

    form.querySelectorAll(".variant-swatch.selected").forEach(function (btn) {
      var idx = parseInt(btn.getAttribute("data-option-index"), 10);
      selected[idx] = btn.getAttribute("data-value");
    });

    function exactVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i] === null || selected[i] === opt;
        });
      });
    }

    // Some colors aren't stocked in every size. If the exact color+size combo
    // doesn't exist, fall back to any variant matching the option just changed,
    // so the photo always reflects the color the shopper picked.
    function variantForImage(changedIdx) {
      var exact = exactVariant();
      if (exact) return exact;
      if (changedIdx === null || changedIdx === undefined) return null;
      return variants.find(function (v) {
        return v.options[changedIdx] === selected[changedIdx];
      });
    }

    function swapImage(changedIdx) {
      var variant = variantForImage(changedIdx);
      if (!variant || !variant.featured_image || !variant.featured_image.src) return;
      setMain(variant.featured_image.src, variant.featured_image.alt);
    }

    form.querySelectorAll(".variant-swatch").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.getAttribute("data-option-index"), 10);
        selected[idx] = btn.getAttribute("data-value");
        swapImage(idx);
      });
    });
  });
})();
